import { GetStrategies } from "../services/financialService";
const requestStrategiesType = "REQUEST_STRATEGIES";
const receiveStrategiesType = "RECEIVE_STRATEGIES";
const initialState = { strategies: [], loading: false };

export const actionCreators = {
  requestStrategies: () => async (dispatch, getState) => {
    let { strategies } = getState().strategies;
    if (strategies && strategies.length > 0) {
      return;
    }
    dispatch({ type: requestStrategiesType });

    strategies = await GetStrategies();

    dispatch({ type: receiveStrategiesType, strategies });
  }
};

export const reducer = (state, action) => {
  state = state || initialState;

  if (action.type === requestStrategiesType) {
    return {
      ...state,
      loading: true
    };
  }

  if (action.type === receiveStrategiesType) {
    const { strategies } = action;
    return {
      ...state,
      strategies,
      loading: false
    };
  }

  return state;
};
